import Icon from '@material-ui/icons/ListAlt';
import TrainingList from './TrainingList'
import TrainingCreate from './TrainingCreate'
import TrainingEdit from './TrainingEdit';
import Show from './TrainingShow'

export default {
    list: TrainingList,
    icon: Icon,
};
